import { FETCH_PROJECTS_BY_PORTEUR } from "../types";

export const projectsByPorteurReducer = (
  state = { isLoading: true, data: [] },
  action
) => {
  switch (action.type) {
    case FETCH_PROJECTS_BY_PORTEUR:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };

    default:
      return state;
  }
};
